import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PropertyList from './components/PropertyList';
import PropertyDetail from './components/PropertyDetail';
import { AppProvider } from './contexts/AppContext';
import './styles/App.css';
import apiService from './services/api';

function AppContent() {
  useEffect(() => {
    // Telegram Web App initialization
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      tg.expand();
      
      // Set theme colors
      tg.setHeaderColor('#2563eb');
      tg.setBackgroundColor('#f8fafc');
    }

    // Identify/create user on app open
    (async () => {
      try {
        let externalId;
        let name, username;

        // Если мы внутри Telegram, всегда используем его данные
        if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
          const u = window.Telegram.WebApp.initDataUnsafe.user;
          externalId = `tg_${u.id}`;
          name = [u.first_name, u.last_name].filter(Boolean).join(' ');
          username = u.username;
        } else {
          // Вне Telegram — берем сохраненный или генерим анонимный
          externalId = localStorage.getItem('extUserId');
          if (!externalId) {
            externalId = `anon_${Math.random().toString(36).slice(2)}`;
          }
        }
        localStorage.setItem('extUserId', externalId);
        
        // Извлекаем app_id из URL
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        const appId = pathParts.length > 0 && uuidRegex.test(pathParts[0]) ? pathParts[0] : null;
        
        await apiService.identifyUser({ externalId, name, username, appId });
      } catch (e) {
        // swallow
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Маршруты с app_id */}
        <Route path="/:appId/property/:id" element={<PropertyDetail />} />
        <Route path="/:appId" element={<PropertyList />} />
        
        {/* Маршруты без app_id */}
        <Route path="/property/:id" element={<PropertyDetail />} />
        <Route path="/" element={<PropertyList />} />
        
        {/* Редирект для неправильных путей */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  // Проверяем, находимся ли мы на поддомене app.realgram.ru без app_id
  useEffect(() => {
    if (window.location.hostname.startsWith('app.')) {
      const pathParts = window.location.pathname.split('/').filter(Boolean);
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      
      if (pathParts.length === 0 || !uuidRegex.test(pathParts[0])) {
        // Редирект на основной домен
        const mainDomain = window.location.hostname.replace('app.', '');
        window.location.href = `${window.location.protocol}//${mainDomain}${window.location.pathname}${window.location.search}${window.location.hash}`;
      }
    }
  }, []);

  return (
    <Router>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </Router>
  );
}

export default App;
